import {useNavigate} from "react-router";
import {useEffect, useState} from "react";
import {useAuthStore} from "../../../store/auth.store";
import {PartnerApi} from "../../../api/partner.api";
import {useTranslation} from "../../../hooks/useTranslation";

export default function CommentNewForm({handleClose, objectType, objectId, callback}) {
    const { t } = useTranslation();
    const [error, setError] = useState(null);
    const [description, setDescription] = useState("");

    const token = useAuthStore((state) => state.token);

    const createComment = (event) => {
        event.preventDefault();
        setError(null);
        const result = PartnerApi.commentAdd({
            token,
            data: {
                comment: description,
                objectType,
                objectId
            }
        });
        result.then((result) => {
            if ("error" in result) {
                setError(result.error);
                return;
            }

            handleClose();
            setDescription("");
            if (callback) {
                callback();
            }
        });
        return false;
    }
    return (
        <form onSubmit={(e) => createComment(e)}>

            {error && (
                <p className="alert alert-danger">{error}</p>
            )}

            <div className="mb-10">
                <label
                       className="required form-label">{t("comments.noteText")}</label>
                <textarea
                       defaultValue={description}
                       required={true}
                       onChange={(e) => setDescription(e.target.value)}
                       className="form-control form-control-solid"
                     />
            </div>


            <button type="submit" className="btn btn-primary">{t("opportunities.saveNote")}</button>
        </form>
    );
}